import React from 'react'
import ReactStars from "react-rating-stars-component";

export default function RatingStars({ viewOnly, value, count, onChange }) {
    return (
        <ReactStars
            onChange={(value) => onChange(value)}
            edit={!viewOnly}
            value={value}
            size={30}
            activeColor={"#ffd700"}
            count={count}
        />
    )
}
